/**
 * Mutable API endpoint roots — updated from /api/public/bootstrap at app startup.
 */

import { normalizeApiOrigin } from './bootstrap-api-url.js';

function trimTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

/** Defaults until GET /api/public/bootstrap runs. */
let apiBaseUrl = normalizeApiOrigin(
  trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'),
);
let locationApiBaseUrl = 'http://localhost:3002';

export function configureApiEndpoints(config: {
  apiBaseUrl: string;
  locationApiBaseUrl: string;
}): void {
  apiBaseUrl = trimTrailingSlash(config.apiBaseUrl);
  locationApiBaseUrl = trimTrailingSlash(config.locationApiBaseUrl);
}

export function getApiBaseUrl(): string {
  return apiBaseUrl;
}

export function getApiUrl(): string {
  return `${apiBaseUrl}/api`;
}

export function getLocationApiUrl(): string {
  return `${locationApiBaseUrl}/api`;
}
